import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useAppSearchParams } from '@utils/hooks/use-app-search-params.ts';

type Channels = Array<
  'alignment' | 'batch' | 'realtime' | 'translation'
> | null;

type Subscription = {
  id: number;
  channels: Channels;
  description: string;
  languages: string[] | null;
  max_active_per_organization: number | null;
  payment_model: number;
  periodic_units: number | null;
  sku: string;
  subscription_period: number;
  units: number | null;
};

type SubscriptionPlanResponse = {
  count: number;
  total_results: number;
  result: Subscription[];
};

export const useGetSubscriptionPlans = (searchQuery = '') => {
  const { searchParams } = useAppSearchParams();
  const offset = parseInt(searchParams.offset || '0');
  const limit = parseInt(searchParams.limit || '1000');

  return useQuery<SubscriptionPlanResponse, AxiosError<BaseError>>(
    ['subscriptions', offset, limit, searchQuery],
    () => {
      const q = searchQuery ? `sku:ilike:%${searchQuery}%` : undefined;

      const params = new URLSearchParams();
      params.set('offset', offset.toString());
      params.set('limit', limit.toString());
      if (q) params.set('q', q);

      return Axios.get<SubscriptionPlanResponse>(
        `${GET_URL(offset.toString(), limit.toString()).resellerPlan}?${params.toString()}`
      ).then(res => res.data);
    },
    {
      keepPreviousData: true
    }
  );
};
